import { StyledProps } from '../types';

export function createVariants<TName extends string>(
  variants: Record<TName, StyledProps>
) {
  return variants;
}
